module.exports = __webpack_public_path__ + "media/bootstrap-icons/water-aae40aed.svg";